import './globalStyles/global.sass';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import EntryPoint from './components/EntryPoint/EntryPoint';
import { Amplify } from 'aws-amplify'
import amplifyConfig from './config/awsAmplifyConfig';

Amplify.configure(amplifyConfig);

ReactDOM.render(
  <React.StrictMode>
    <EntryPoint />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
